import { FC, useEffect, useState } from "react"
import s from "./UpdateStoks.module.css"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import {
  deleteDataFromKatren,
  selectUpdateStoksKatrenStore,
  updateKatrenStoksState,
  uploadDataFromKatren,
} from "../../app/reducers/updateStoksKatren"
import { Tabs } from "../Tabs/Tabs"
import { TabContent } from "../Tab/TabContent"
import { UploadMultipleFilesFromKatren } from "./UploadMultipleFilesFromKatren"
import { UploadFileFromKatren } from "./UploadFileFromKatren"
import { selectOrdersStore } from "../../app/reducers/ordersReducer"
import { WildberriesTab } from "./WbTabUpdateStoks"
import { OzonTabUpdateStoks } from "./OzonTabUpdateStoks"
import {
  selectActiveShops,
  SHOP_IDENT,
} from "../../app/reducers/settingsReducer"
import { useNavigateSubTab } from "../../utils/hooks/useNavigateTab"
import { YandexTabUpdateStoks } from "./YandexTabUpdateStoks"
import { WBTokenGuard } from "../WBTokenGuard/WBTokenGuard"

export const UpdateStoksKatren: FC = () => {
  const dispatch = useAppDispatch()
  useState(false)
  useEffect(() => {
    dispatch(updateKatrenStoksState())
  }, [])
  const updateStoksStore = useAppSelector(selectUpdateStoksKatrenStore)
  const ordersStore = useAppSelector(selectOrdersStore)
  const { storages, ozonStorages, yandexCampaigns } = ordersStore
  const {
    lastStoksUpdated,
    lastPricesUpdated,
    status,
    isCurrentDataUploaded,
    isDataFromKatrenUploaded,
    isPromotionDataUploaded,
    errors,
    ozon,
    ya,
  } = updateStoksStore
  const activeShops = useAppSelector(selectActiveShops)
  const [activeSubTab, navigate] = useNavigateSubTab()

  const shops = []
  activeShops.includes(SHOP_IDENT.KATREN) &&
    shops.push(
      <TabContent name={"wildberries"} ident={"wildberries"}>
        <WBTokenGuard>
          <WildberriesTab
            lastStoksUpdated={lastStoksUpdated}
            lastPricesUpdated={lastPricesUpdated}
            isCurrentDataUploaded={isCurrentDataUploaded}
            isDataFromKatrenUploaded={isDataFromKatrenUploaded}
            isPromotionDataUploaded={isPromotionDataUploaded}
            status={status}
            storages={storages}
            errors={errors}
          />
        </WBTokenGuard>
      </TabContent>,
    )
  activeShops.includes(SHOP_IDENT.KATREN_OZON) &&
    shops.push(
      <TabContent name={"ozon"} ident={"ozon"}>
        <OzonTabUpdateStoks
          lastStoksUpdated={ozon?.lastStoksUpdated ?? ""}
          lastPricesUpdated={ozon?.lastPricesUpdated ?? ""}
          isCurrentDataUploaded={ozon?.isCurrentDataUploaded ?? false}
          isDataFromKatrenUploaded={isDataFromKatrenUploaded}
          status={ozon?.status}
          storages={ozonStorages}
        />
      </TabContent>,
    )

  activeShops.includes(SHOP_IDENT.KATREN_YANDEX) &&
    shops.push(
      <TabContent name={"yandex"} ident={"yandex"}>
        <YandexTabUpdateStoks
          lastStoksUpdated={ya?.lastStoksUpdated ?? ""}
          lastPricesUpdated={ya?.lastPricesUpdated ?? ""}
          isCurrentDataUploaded={ya?.isCurrentDataUploaded ?? false}
          isDataFromKatrenUploaded={isDataFromKatrenUploaded}
          status={ya?.status}
          storages={yandexCampaigns}
        />
      </TabContent>,
    )

  return (
    <div className={s.updateStoksWrapper}>
      <h5>Загрузка остатков и обновление цен</h5>
      <div>
        <div className={s.uploadFilesWrap}>
          <Tabs>
            <TabContent
              name={"Загрузить файл цен и остатков с Катрена"}
              ident={"oneFile"}
            >
              <UploadFileFromKatren
                deleteDataFromKatren={() => {
                  dispatch(deleteDataFromKatren())
                }}
                uploadDataFromKatren={(
                  data: { name: string; amount: number; price: number }[],
                  fileName?: string,
                ) => {
                  dispatch(uploadDataFromKatren({ data, fileName }))
                }}
                isDataFromKatrenUploaded={isDataFromKatrenUploaded}
              />
            </TabContent>
            <TabContent
              name="Загрузить несколько файлов цен и остатков с Катрена"
              ident={"multipleFiles"}
            >
              <UploadMultipleFilesFromKatren
                deleteDataFromKatren={() => {
                  dispatch(deleteDataFromKatren())
                }}
                uploadDataFromKatren={(
                  data: {
                    name: string
                    amount: number
                    price: number
                    priceInfo?:
                      | {
                          price: number
                          storage?: string | undefined
                        }[]
                      | undefined
                  }[],
                  fileName?: string,
                ) => {
                  dispatch(uploadDataFromKatren({ data, fileName }))
                }}
                isDataFromKatrenUploaded={isDataFromKatrenUploaded}
              />
            </TabContent>
          </Tabs>
        </div>
        <div>
          <Tabs activeTabIdent={activeSubTab} onChange={navigate}>
            {...shops}
          </Tabs>
        </div>
      </div>
    </div>
  )
}
